import { Attributes, ModelBase, NeoModel, Rules, Model, Validation, Misc } from "@singularsystems/neo-core";
import { TradeDistributionTypeEnum } from "../Enums/TradeDistributionTypeEnum";
import ServiceProviderFileGroupingExportSettingLookup from "./ServiceProviderFileGroupingExportSettingLookup";

@NeoModel
export default class ServiceProviderFileGroupingLookup extends ModelBase {

    @Attributes.Nullable()
    public staticServiceProviderId: number = 0;

    public staticServiceProviderFileGroupingId: number = 0;

    @Rules.Required()
    @Rules.StringLength(254)
    public serviceProviderName: string = "";

    @Rules.Required()
    @Rules.StringLength(6)
    public serviceProviderCode: string = "";

    @Rules.Required()
    @Rules.StringLength(20)
    public serviceProviderSubAccountName: string = "";

    @Rules.Required()
    @Rules.StringLength(200)
    public serverName: string = "";

    @Rules.StringLength(100)
    @Rules.Required()
    public serviceProviderGroupingName: string = "";

    @Rules.StringLength(1000)
    @Rules.Required()
    public groupingDescription: string = "";

    @Rules.StringLength(400)
    @Rules.Required()
    public databaseName: string = "";

    public isOnshoreInd: boolean = false;

    public ignoreGroupingInd: boolean = false;

    public isActiveInd: boolean = false;

    public importsPublicHolidaysInd: boolean = false;

    public ignoresExchangeRatesInd: boolean = false;

    public clientAltSearchInd: boolean = false;

    @Rules.StringLength(100)
    @Rules.Required()
    public sortOrder: string = "";

    public provideDividendGrossInd: boolean = false;

    public useAccountCurrencyInd: boolean = false;

    public daysOfWeek: string[] = [];

    public daysOfWeekNumbers: number[] = [];

    @Attributes.NoTracking()
    public selectedDaysOfWeek: Model.ISelectedItem[] = [];

    public tradeDistributionTypeId: TradeDistributionTypeEnum | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public exportTime: Date | null = null;

    public exportSettingLookupList: ServiceProviderFileGroupingExportSettingLookup[] = [];

    public isWacEnabled: boolean = false;

    @Rules.StringLength(50)
    public eventIdFieldName: string = "";

    public samReporting: number | null = null;

    public isBroker: boolean = true;

    public isBookCostRunning: boolean = false;

    @Attributes.Date(Misc.TimeZoneFormat.UTC)
    public lastDailyReportSync: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public lastLBVHRun: Date | null = null;

    public lastLBVHVariant: string = "secondary";

    public lastLBVHRelative: string = "";

    public lastLBVHDisplay: string = "";

    public exportToSFTP: boolean = false;

    public exportToAPI: boolean = false;

    @Rules.StringLength(500)
    public criticalFailureRecipients: string | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}